import React from "react";
import {
    faBolt,
    faCompressArrowsAlt,
    faIndustry, faLock,
    faShieldAlt,
    faTintSlash,
} from "@fortawesome/free-solid-svg-icons";
import ProductTypes from "../../components/ProductTypes";

const ElectricalAutomotive = () => {
    const products = [
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759242759/BlindStandoffs_ikm3w8.webp", name: "Blind Standoffs" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165605/FlushHeadStuds_vskogx.webp", name: "Flush Head Studs" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165612/HexWeldNuts_iwjqrc.webp", name: "Hex Weld Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165644/SelfClinchingNuts_rksv6u.webp", name: "Self Clinching Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759171102/BlindNuts_g0g7wc.webp", name: "Blind Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165653/ThroughStandoffs_fzxdeh.webp", name: "Standoffs" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1762070810/RivetNuts_bnbobx.webp", name: "Rivet Nuts M5" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165647/SemiTabularRivets_bkvkfa.webp", name: "Semi Tabular Rivets" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165650/SolidRivets_gzdimd.webp", name: "Solid Rivets" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759601197/ExternalCirclips_ivssyh.webp", name: "External Circlips" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1760968659/ClosedEndRivetNuts_f1grgi.webp", name: "Closed End Hex Rivet" },
    ];

    const bannerImage = "https://res.cloudinary.com/dbirahuue/image/upload/v1759157232/ElectricalAutomotive_bmknxc.webp";
    const heading = "Electrical & Automotive";
    const description =
        "Electrical and automotive industries require fastening solutions that combine high strength, safety, and resistance to harsh environments. At Vibha Enterprises, we provide globally sourced, high-quality fasteners engineered for secure assembly and long-term reliability.";

    const benefits = [
        { icon: faIndustry, text: "Optimized for sheet metal and enclosure assemblies" },
        { icon: faShieldAlt, text: "Provides consistent mechanical strength and reliability" },
        { icon: faTintSlash, text: "Corrosion-resistant and durable" },
        { icon: faCompressArrowsAlt, text: "Space-saving design ideal for compact assemblies" },
        { icon: faBolt, text: "Simplifies installation and reduces assembly time" },
        { icon: faLock, text: "Enhances safety and performance in electrical applications" },
    ];

    return (
        <ProductTypes
            products={products}
            image={bannerImage}
            heading={heading}
            description={description}
            benefits={benefits}
        />
    );
};

export default ElectricalAutomotive;
